// extracted by mini-css-extract-plugin
export default {"example":"Notification_example__S33sR"};